<template>
  <div>
    <h1>Dashboard</h1>
    <p>Welcome to the dashboard</p>
  </div>
</template>

<script setup>
import { useAuthStore } from "@/stores/authStore";
import { onBeforeMount } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

const authStore = useAuthStore();
onBeforeMount(() => {
  // herhangi bir paket seçilmediyse, kullanıcıyı abonelikler sayfasına yönlendir
  if (!authStore.user.IsPackageSelected) {
    router.push("subscriptions");
  }
});
</script>
